'use client'
import React from 'react'
import Typography from 'src/components/design-system/Typography'
import { useTranslateEntry } from 'src/i18n/client/useTranslateEntry'
import { getMediaUrl } from 'src/_helpers/client/getMediaUrl'
import Image from 'next/image'
// icon
import Address from 'public/icons/interface/address.svg'
import Phone from 'public/icons/interface/phone.svg'
import Email from 'public/icons/interface/e-mail.svg'
import { getPreferredTranslation } from 'src/_helpers/getPreferredTranslation'
// end icon
export default function Affiliation({ page, locale, className }) {
  const translate = useTranslateEntry()
  const affiliation = page.affiliations?.[0] || null
  const affiliationTranslate = getPreferredTranslation(affiliation, locale) || {}
  const affiliationTitle = affiliationTranslate?.title
  const affiliationAlt = affiliationTranslate?.alt || affiliationTranslate?.title
  const affiliationThumb = affiliation?.thumbs?.journal
  const affiliationThumbUrl = affiliationThumb ? getMediaUrl(affiliationThumb.url, affiliationThumb.version) : null
  const pageTranslation = getPreferredTranslation(page, locale) || {}
  const contactAddress = pageTranslation.contactAddress || page.contactAddress
  const contactEmail = pageTranslation.contactEmail || page.contactEmail
  const contactPhone = pageTranslation.contactPhone || page.contactPhone
  const contact = contactAddress || contactPhone || contactEmail
  const hasContent = affiliationTitle || affiliationThumbUrl || contact
  const hasRowContent = affiliationThumbUrl || contact

  if (!hasContent) {
    return null
  }

  return (
    <section className={`d:p-40 py-24 px-16 border-t border-t-dark-blue-dark-blue6 ${className}`}>
      {affiliationTitle && (
        <Typography variant="h3-bold" component="span" color="text-basic-black" className="pb-32 block">
          {affiliationTitle}
        </Typography>
      )}
      {hasRowContent && (
        <div className="flex d:items-center gap-x-32 flex-col d:flex-row gap-y-24">
          <hr className="hidden d:block w-1 h-126 bg-dark-blue-dark-blue6 text-dark-blue-dark-blue6" />
          {affiliationThumbUrl && (
            <div>
              <Image
                className="w-auto h-full"
                src={affiliationThumbUrl}
                alt={affiliationAlt}
                width={affiliationThumb.width}
                height={affiliationThumb.height}
              />
            </div>
          )}
          {affiliationThumbUrl && contact && (
            <hr className="hidden d:block w-1 h-126 bg-dark-blue-dark-blue6 text-dark-blue-dark-blue60" />
          )}
          {contact && (
            <div>
              <Typography variant="h3-bold" component="span" color="text-basic-black" className="pb-24 block">
                {translate('T_JOURNAL_CONTACT')}
              </Typography>
              {contactAddress && (
                <div className="flex flex-col gap-y-8">
                  <div className="flex items-center gap-x-4">
                    <Address />
                    <Typography variant="h4" component="span" color="text-basic-black" className="block w-fit h-fit">
                      {contactAddress}
                    </Typography>
                  </div>
                </div>
              )}

              {contactEmail && (
                <a href={`mailto:${contactEmail}`} className="flex items-center gap-x-4">
                  <Email />
                  <Typography variant="h4" component="span" color="text-basic-black" className="block w-fit h-fit">
                    {contactEmail}
                  </Typography>
                </a>
              )}

              {contactPhone && (
                <a href={`tel:${contactPhone.trim().replace(/\s+/g, '')}`} className="flex items-center gap-x-4">
                  <Phone />
                  <Typography variant="h4" component="span" color="text-basic-black" className="block w-fit h-fit">
                    {contactPhone}
                  </Typography>
                </a>
              )}
            </div>
          )}
        </div>
      )}
    </section>
  )
}
